(function () {
  'use strict';
  function alignSection() {
    if (location.hash !== '#jar-labels') return;
    var section = document.getElementById('jar-labels');
    if (section) section.scrollIntoView({block:'start',behavior:'instant'});
  }
  if (location.hash === '#jar-labels') {
    if (document.readyState === 'complete') setTimeout(alignSection, 0);
    else window.addEventListener('load', function () { setTimeout(alignSection, 0); }, {once:true});
  }
  var data = window.VP_JAR_LABEL_DATA;
  if (!data || !Array.isArray(data.products)) return;
  document.querySelectorAll('[data-jl-from]').forEach(function (node) {
    var product = data.products.find(function (item) { return item.id === node.dataset.jlFrom; });
    if (!product || !product.variants.length) return;
    var variants = product.variants.filter(function (item) { return item.available; });
    if (!variants.length) { node.textContent = 'View availability ↗'; return; }
    var cents = Math.min.apply(null, variants.map(function (item) { return item.price; }));
    node.textContent = 'From ' + new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100) + ' each ↗';
  });
}());
